import React, { Component } from 'react';
import deviceDOMHoc from '../../hocs/deviceDOMHoc';
import {
  inject,
  observer,
} from 'mobx-react';

@inject('scoreboardStore', 'batchStore', 'scheduleStore')
@observer
class Scoreboard extends Component {
  render() {
    const { device, scoreboardStore, batchStore, scheduleStore } = this.props;
    const { running, queue } = batchStore;
    const { schedules } = scheduleStore;
    const truckData = scoreboardStore.getTruckData(device, [ ...running, ...queue, ...schedules ]);

    return (
      <div id={`device-${device.id}`} className={'device-gui device-gui--scoreboard'}>
        <div className="device-label device-icon">
          <div className="device-type" title={`#${device.id}`}>{device.description}</div>
        </div>
        <div className="device-icon body" onClick={() => scoreboardStore.displayTrucks()}>
          {truckData.map((truck, i) => (
            <div key={truck || i}>{truck}</div>
          ))}
        </div>
      </div>
    );
  }
}

export default deviceDOMHoc(Scoreboard);
